import styled from 'styled-components';

export const ModalContainer = styled.div`
  z-index: 9999;
  width: 100%;
  height: 100vh;
  position: absolute;
  top: 0px;
  left: 0px;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const BoxFieldOptionsModal = styled.div`
  display: block;
  background: white;
  width: 60%;
  height: 480px;
  padding: 1rem;
  overflow-y: scroll;
  border-radius: 1rem
`;

export const HeaderModal = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px #EDEDED solid;
  padding: 5px;
  margin-bottom: 10px;
  padding-bottom: 20px;
`;

export const ContentModal = styled.div`
  display: flex;
  flex: 2;
  flex-direction: column;
`;

export const InputContainer = styled.div`
  margin-bottom: 10px;
`;

export const InputOptionsContainer = styled.div`
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  gap: 10px;
`;

export const Footer = styled.footer`
  display: flex;
  justify-content: flex-end;
  border-top: 1px #EDEDED solid;
`;

export const SwitchContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 15px;
`;
